// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QV9wu","right":"styles_right__124qE"};